import { render, staticRenderFns } from "./HeaderCategoriesDropdown.vue?vue&type=template&id=4eb2c575&"
import script from "./HeaderCategoriesDropdown.vue?vue&type=script&lang=js&"
export * from "./HeaderCategoriesDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports